module.exports = __webpack_public_path__ + "static/img/4.9701283.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka3/4.jpg
// module id = 1DWk
// module chunks = 16